import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";
import axios from "axios";
import config from "../services/config.json";
import { DatePicker, Row, Col } from "antd";

const Logs = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState([]);
  const [adOptions, setAdOptions] = useState([]);
  const [subTotal, setSubTotal] = useState("");
  const [countEmail, setCountEmail] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const { RangePicker } = DatePicker;
  const [filters, setFilters] = useState({
    origin: "",
    ad_number: "",
    compaign_source: "",
    type: "",
    source: "",
    ip_address: "",
    page_url: "",
    date_range: [],
    lead_type: "",
    id: "",
  });

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    fetchData({ pagination: { ...pagination, current: 1 }, filters: newFilters });
  };

  const fetchAdOptions = async () => {
    try {
        const response = await axios.get(`${config.apiEndPoint}get_ads_options`, {
      });

     const result = response.data;
     if(result && result.status == 1) {
      setAdOptions(result.ad_name);
     }
      
  

      // setData(result.data);
      // setTotal(result.source_summary);
      // setSubTotal(result.total);
      // console.log("debugging data", result.data)
      // setPagination({
      //   current: result.current_page,
      //   pageSize: result.per_page,
      //   total: result.total,
      // });
    } catch (error) {
      console.error("Failed to fetch logs:", error);
    }
  };
  

  const fetchData = async (params = {}) => {
    setLoading(false);
    try {
        const response = await axios.get(`${config.apiEndPoint}get_logs`, {
            params: {
                page: params.pagination?.current || 1,
                per_page: params.pagination?.pageSize || 15,
                origin: params.filters?.origin || "",
                ad_number: params.filters?.ad_number || "",
                compaign_source: params.filters?.compaign_source || "",
                type: params.filters?.type || "",
                source: params.filters?.source || "",
                ip_address: params.filters?.ip_address || "",
                page_url: params.filters?.page_url || "",
                date_range: params.filters?.date_range || [],
                lead_type: params.filters?.lead_type || "",
                id: params.filters?.id || "",
              },
      });

      const result = response.data;

      setData(result.data);
      setTotal(result.source_summary);
      setSubTotal(result.total);
      setCountEmail(result.email_count);
      setPagination({
        current: result.current_page,
        pageSize: result.per_page,
        total: result.total,
      });
    } catch (error) {
      console.error("Failed to fetch logs:", error);
    }
    setLoading(false);
  };
  

  useEffect(() => {
    fetchData({ pagination, filters });
    fetchAdOptions();
  }, []);

  const handleTableChange = (pagination) => {
    fetchData({ pagination, filters });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    const newFilters = { ...filters, origin: value };
    setFilters(newFilters);
    fetchData({ pagination: { ...pagination, current: 1 }, filters: newFilters });
  };

  const columns = [
    {
        title: "No.",
        key: "index",
        render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
      },
       {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
        title: "Origin",
        dataIndex: "origin",
        key: "origin",
             render: (text) => {
    if (!text) return "";

    const normalized = text.toLowerCase();

    switch (normalized) {
      case "google_ads":
        return "Google Ads";
      case "gbp":
        return "Google Business Profile";
      case "chatgpt.com":
        return "ChatGPT";
      case "bing_ads":
        return "Bing Ads";
      case "Email":
        return "Email Signature";
      default:
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
  },
  //       render: (text) => {
  //   if (!text) return "";
  //   switch (text) {
  //     case "Email":
  //       return "Email Signature";
  //     default:
  //       return text;
  //   }
  // },
      },
      {
        title: "Ad Campaign",
        dataIndex: "ad_number",
        key: "ad_number",
         render: (text, record) => {
    if (!text) {
 const utmCampaign = new URLSearchParams(record.page_url).get('utm_campaign');
let formattedCampaign = '';

if (utmCampaign) {
  if (utmCampaign == 'wills') {
    formattedCampaign = 'Anda';
  } else if (utmCampaign == 'wills-nimi') {
    formattedCampaign = 'Nimi';
   } else if (utmCampaign == 'nimi-buying-your-first-property') {
    formattedCampaign = 'Nimi Buying Your First Property';
  } else {
    formattedCampaign = utmCampaign.charAt(0).toUpperCase() + utmCampaign.slice(1);
  }
}

return formattedCampaign || (record.origin === "Tiktok" || record.origin === "Meta" || record.origin === "Linkedin" ? "-" : "Organic");

}
    switch (text) {
      case "22308841429":
        return "Brand Campaign -Homepage";
      case "22848579250":
        return "Inhouse Partnerships & Collaborations";
      case "22402309107":
        return "GBP - raalc.ae";
      case "22331233849":
        return "Inhouse-Realestate-2025";
      case "22342145650":
        return "Inhouse-realestate-global";
        case "22334799973":
        return "Inhouse-realestate-feeder";
      case "21869242248":
        return "RAALC| Real estate| UAE";
      case "22397792280":
        return "Inhouse-corporate-feeder";
      case "22408256059":
        return "Inhouse-Corporate-Feeder-2";
         case "21874121411":
        return "RAALC | Corporate Law| UAE";
      case "22433374065":
        return "In-House Commercial";
      case "22440172004":
        return "InHouse - Commercial Feeder";
      case "22492221812":
        return "Inhouse - Trust & Fundation";
        case "22473084201":
        return "Inhouse-Arabic-General";
      case "21880852763":
        return "OMG | Search | Generic | ar";
      case "22554901378":
        return "In-House Generic Chinese";
      case "21882320785":
        return "Russian Ad";
        case "21884906857":
        return "RAALC| Russian LP| UAE";
      case "22467674322":
        return "search_corporate";
      case "22346999897":
        return "Search_corporate";
      case "21999289407":
        return "Lawyer Services in Dubai";
      case "22735745988":
        return "Inhouse- Chinese-PMax";
      case "22931777989":
        return "ShortVideo - Buying property-Nimi";
      case "22816253643":
        return "search_corporate_new";
       case "22816253640":
        return "search_general_new";
        case "22964400120":
        return "Video - What is Trusts - Israa";
        case " 22978201141":
        return "Real estate - Pmax";
      case "wills":
        return "Anda";
       case "wills-nimi":
        return "Nimi";
        case "nimi-buying-your-first-property":
        return "Nimi Buying Your First Property";
        case "what-is-trust":
        return "What is Trust";
        case "Noanswer_lost":
        return "No Answer Lost";
        case "two-real-estate-tips-zaur":
        return "Two Real Estate Tips Zaur";
        case "what-is-foundation":
        return "What is foundation";
        case "property-handover-russia":
        return "Property Handover Russia"; 
      default:
        return text;
    }
  },
      },
       {
        title: "Compaign Source",
        dataIndex: "compaign_source",
        key: "compaign_source",
         render: (text) => {
    if (!text) return "";

    const normalized = text.toLowerCase();

    switch (normalized) {
      // case "g_m":
      // case "g_c":
      // case "x_m":
      // case "x_c":
      case "google_ads":
      // case "google":
        return "Google Ads";
      case "gbp":
        return "Google Business Profile";
      case "chatgpt.com":
        return "ChatGPT";
      // case "clutch.co":
      //   return "Clutch Website";
      case "bing_ads":
        return "Bing Ads";
      case "Email_marketing":
        return "Email Marketing";
      default:
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
  },
      },
    {
      title: "Page",
      dataIndex: "page_url",
      key: "page_url",
    //   render: (url) => url?.split("?")[0],
    },
    {
        title: "Time",
        dataIndex: "created_at",
        key: "created_at",
      },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
      {
        title: "Type",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "Source",
        dataIndex: "source",
        key: "source",
      },
      {
        title: "Phone Number",
        dataIndex: "phone_number",
        key: "phone_number",
      },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Logs</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 16, marginTop: 25 }}>

  {/* Origin */}
  <select
  value={filters.origin}
  onChange={(e) => handleFilterChange("origin", e.target.value)}
  style={{
    padding: "4px 10px",
    borderRadius: 4,
    border: "1px solid #d9d9d9",
    backgroundColor: "#fff",
    color: "#000",
  }}
>
  <option value="">All Origins</option>
  <option value="Website">Website</option>
  <option value="Commercial">Commercial</option>
  <option value="Corporate">Corporate</option>
  <option value="Real Estate">Real Estate</option>
  <option value="Paris Arbitration Week">Paris Arbitration Week</option>
  <option value="Arabic">Arabic</option>
  <option value="Chinese">Chinese</option>
  <option value="Trust and Foundations">Trust and Foundations</option>
  <option value="Email">Email Signature</option>
  {/* <option value="Linkedin">Linkedin</option> */}
  <option value="Consult">Consult</option>
  <option value="RAALC ME">RAALC ME</option>
  <option value="RAALC ME Russian">RAALC ME Russian</option>
  <option value="RAALC ME Real Estate">RAALC ME Real Estate</option>
  <option value="Partnerships and Collaborations">Partnerships and Collaborations</option>
  <option value="Family Office">Family Office</option>
  <option value="Ossama Landing Page">Ossama Landing Page</option>
</select>


  {/* Type */}
  <select
    value={filters.type}
    onChange={(e) => handleFilterChange("type", e.target.value)}
    style={{
        padding: "4px 10px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        color: "#000",
      }}
  >
    <option value="">All Types</option>
    <option value="whatsapp">WhatsApp</option>
    <option value="phone">Phone</option>
    <option value="Redirection">Redirection</option>
  </select>

  {/* Source */}
  <select
    value={filters.source}
    onChange={(e) => handleFilterChange("source", e.target.value)}
    style={{
        padding: "4px 10px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        color: "#000",
      }}
  >
    <option value="">All Sources</option>
    <option value="Web">Web</option>
  </select>

      {/* Page URL Input */}
      <Input
    placeholder="Filter by Page"
    value={filters.page_url}
    onChange={(e) => handleFilterChange("page_url", e.target.value)}
    style={{ width: 220 }}
  />

   {/* Ad Campaign Input */}
  <select
      value={filters.ad_number}
      onChange={(e) => handleFilterChange("ad_number", e.target.value)}
      style={{
        padding: "4px 10px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        color: "#000",
      }}
    >
      <option value="">All Ads</option>
      {adOptions.map((option) => (
        <option key={option.number} value={option.number}>
          {option.name}
        </option>
      ))}
    </select>

   {/* <Input
    placeholder="Filter by Ad Campaign"
    value={filters.ad_number}
    onChange={(e) => handleFilterChange("ad_number", e.target.value)}
    style={{ width: 220 }}
  /> */}

    {/* Compaign Source Input */}
  <select
    value={filters.compaign_source}
    onChange={(e) => handleFilterChange("compaign_source", e.target.value)}
    style={{
        padding: "4px 10px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        color: "#000",
        width: 220
      }}
      
  >
    <option value="">All Compaign Sources</option>
    <option value="Google_Ads">Google Ads</option>
    <option value="gbp">Google Business Profile</option>
    <option value="chatgpt.com">ChatGPT</option>
    <option value="Bing_Ads">Bing Ads</option>
    <option value="Facebook">Facebook</option>
    <option value="Instagram">Instagram</option>
    <option value="Linkedin">Linkedin</option>
    <option value="Meta">Meta</option>
    <option value="Tiktok">Tiktok</option>
  </select>

  {/* IP Address Input */}
  <Input
    placeholder="Filter by IP Address"
    value={filters.ip_address}
    onChange={(e) => handleFilterChange("ip_address", e.target.value)}
    style={{ width: 220 }}
  />

<RangePicker
  onChange={(dates, dateStrings) => {
    handleFilterChange("date_range", dateStrings); // Store range as [startDate, endDate]
  }}
  style={{ borderRadius: 4 }}
  placeholder={["Start Date", "End Date"]}
/>

{/* Compaign Source Input */}
  <select
    value={filters.lead_type}
    onChange={(e) => handleFilterChange("lead_type", e.target.value)}
    style={{
        padding: "4px 10px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        color: "#000",
        width: 220
      }}
      
  >
    <option value="">All Lead Types</option>
    <option value="organic">Organic</option>
    <option value="non_organic">Non Organic</option>
  </select>

   {/* Page URL Input */}
      <Input
    placeholder="Filter by ID"
    value={filters.id}
    onChange={(e) => handleFilterChange("id", e.target.value)}
    style={{ width: 220 }}
  />

</div>

<div style={{paddingTop: 18}}>
<Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{fontWeight: 600}}>Total: {subTotal ? subTotal : "0"}</h1>
        </div>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{fontWeight: 600}}>Non Organic: {subTotal && total ? subTotal - total.organic : "0"}</h1>
        </div>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{fontWeight: 600}}>Organic: {total && total.organic ? total.organic : "0"}</h1>
        </div>
      </Col>
       <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{fontWeight: 600}}>Google Ads: {total && total.Google_Ads ? total.Google_Ads : "0"}</h1>
        </div>
      </Col>
    </Row>
</div>

<div style={{paddingTop: 18, paddingBottom: 18}}>
<Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{fontWeight: 600}}>Google Business Profile: {total && total.gbp ? total.gbp : "0"}</h1>
        </div>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
         <h1 style={{ fontWeight: 600 }}>
  ChatGPT: {total && total['chatgpt.com'] ? total['chatgpt.com'] : "0"}
</h1>

        </div>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{ fontWeight: 600 }}>
  Bing Ads: {total && total['Bing_Ads'] ? total['Bing_Ads'] : "0"}
</h1>
        </div>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
          <h1 style={{fontWeight: 600}}>Facebook: {total && total.Facebook ? total.Facebook : "0"}</h1>
        </div>
      </Col>
    </Row>
</div>

<div style={{paddingBottom: 18}}>
<Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={8}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
           <h1 style={{fontWeight: 600}}>Instagram: {total && total.Instagram ? total.Instagram : "0"}</h1>
        </div>
      </Col>
       <Col xs={24} sm={12} lg={8}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
           <h1 style={{fontWeight: 600}}>Linkedin: {total && total.Linkedin ? total.Linkedin : "0"}</h1>
        </div>
      </Col>
       <Col xs={24} sm={12} lg={8}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
           <h1 style={{fontWeight: 600}}>Email Signature: {countEmail ? countEmail : "0"}</h1>
        </div>
      </Col>
    </Row>
</div>

<div style={{paddingBottom: 24}}>
<Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={12}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
           <h1 style={{fontWeight: 600}}>Meta: {total && total.Meta ? total.Meta : "0"}</h1>
        </div>
      </Col>
       <Col xs={24} sm={12} lg={12}>
        <div style={{ background: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
           <h1 style={{fontWeight: 600}}>Titok: {total && total.Tiktok ? total.Tiktok : "0"}</h1>
        </div>
      </Col>
    </Row>
</div>



      <Table
        columns={columns}
        rowKey={(record, index) => record.id || index}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Logs;